<template>
  <div id="default-map-container" v-bind:style="{ height: mapHeight }">
    <map-view v-on:update-map="$emit('update-map')"></map-view>
  </div>
</template>

<script>
import MapView from '@/components/MapView.vue'

export default {
  name: 'default',
  data: function() {
    return {
      mapHeight: 0,
    }
  },
  components: {
    MapView,
  },
  methods: {
    resizeElements: function() {
      this.mapHeight = (window.innerHeight * 0.65) + 'px' 
      if (window.innerHeight <= 768) {
        this.mapHeight = (window.innerHeight * 0.7) + 'px'
      }
    }
  },
  mounted: function() {
    this.$gtag.event('DevApp lauched')
    this.$gtag.pageview({
      page_path: '/' + this.$i18n.languageUrl
    })

    this.resizeElements()
  }
}
</script>


<style scoped lang="scss">
@import '@/scss/app.scss';
</style>
